import { render, staticRenderFns } from "./Home.af-data.vue?vue&type=template&id=57acde88&scoped=true&"
import script from "./Home.af-data.vue?vue&type=script&lang=js&"
export * from "./Home.af-data.vue?vue&type=script&lang=js&"
import style0 from "./Home.af-data.vue?vue&type=style&index=0&id=57acde88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57acde88",
  null
  
)

export default component.exports